import { IonContent, IonPage, IonList, IonItemDivider } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import './Times.page.css'
import React from 'react'
import TimesGrid from '../timesGrid/timesGrid.component'
import { useTranslation } from 'react-i18next'
import ScrollToTopButton from '../../../components/scrollToTopButton/ScrollToTopButton.component'
import { getScrollToTopSelector } from '../../../components/scrollToTopButton/selectors'

import { toggleScrollToTop } from '../../../components/scrollToTopButton/store/scrollToTop.actions'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'

const Times: React.FC = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()

  const scrollToTopButton = useSelector(getScrollToTopSelector)
  const { isVisible } = scrollToTopButton

  const onScroll = (e: CustomEvent) => {
    dispatch(toggleScrollToTop(e.detail.currentY))
  }

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  return (
    <IonPage id='TimesPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        title={t('times.pageTitle')}
      />
      <IonContent fullscreen color='light' scrollEvents onIonScroll={onScroll}>
        <IonList>
          <TimesGrid />
        </IonList>
        <IonItemDivider color='light' className='scroll-to-top' />
      </IonContent>

      {isVisible && <ScrollToTopButton isHorizontalEnd />}
    </IonPage>
  )
}

export default Times
